(function () {
	'use strict';

	angular.module('l4b')
		.component('secureLogos', {
			templateUrl: 'html/shared/secureLogos/secureLogos.html',
			controllerAs: 'vm',
		});
})();